import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { EmptyStateProps } from "./EmptyState.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: EmptyStateProps) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: 16,
    textAlign: props.align,
    [theme.breakpoints.up("md")]: {
      padding: 24,
    },
  }),
  icon: (props: EmptyStateProps) => ({
    display: props.backgroundIcon ? "block" : "flex",
    margin: props.backgroundIcon ? "0 auto" : "",
    padding: props.backgroundIcon ? 20 : 0,
    borderRadius: props.backgroundIcon ? 8 : 0,
    justifyContent: props.align === "center" ? "center" : "",
    "& svg": {
      color: getIconColor(props, theme),
    },
    [theme.breakpoints.down("lg")]: {
      "& svg": {
        width: 32,
        height: 32,
      },
    },
    [theme.breakpoints.up("md")]: {
      "& svg": {
        width: 48,
        height: 48,
      },
    },
    backgroundColor: getBackgroundColor(props, theme),
  }),
  title: {
    position: "relative",
  },
  content: {
    flex: "1",
  },
  message: {
    position: "relative",
  },
  extra: {
    marginTop: 12,
    position: "relative",
  },
}));

function getIconColor(props: EmptyStateProps, theme: Theme) {
  switch (props.iconColor) {
    case "primary":
      return theme.palette.primary.main;
    default:
      return theme.palette.grey[900];
  }
}

function getBackgroundColor(props: EmptyStateProps, theme: Theme) {
  switch (props.backgroundIcon) {
    case "grey":
      return theme.palette.grey[100];
    default:
      return theme.palette.grey[50];
  }
}
